import { ModelTemplate, NM, SM } from "@models/base/helper-types";
import { MainMenuFolderType, MainMenuItem, MainMenuItemType } from "./main-menu-item";

const mmhf: SM<(rights: SM<any>) => boolean> = {
    mentions: (r: SM<any>) => !r.task && !r.chat,
    events: (r: SM<any>) => !r.calendar,
    projects: (r: SM<any>) => !r.task,
    kanbans: (r: SM<any>) => !r.task,
    tasks: (r: SM<any>) => !r.task,
    newtask: (r: SM<any>) => !r.canCreateTasks,
    support: (r: SM<any>) => r.enterprise,
    chats: (r: SM<any>) => !r.chat,
    tariffs: (r: SM<any>) => r.enterprise || !r.granted?.['org.admin'],
    download: (r: SM<any>) => r.enterprise,
    tasksFolder: (r: SM<any>) => !r.task,
    kanbansFolder: (r: SM<any>) => !r.task,
    groupChatsFolder: (r: SM<any>) => !r.chat,
    directChatsFolder: (r: SM<any>) => !r.chat,
    favorites: (r: SM<any>) => !r.task,
    inbox: (r: SM<any>) => !r.task,
    outgoing: (r: SM<any>) => !r.task,
    inprogress: (r: SM<any>) => !r.task,
    sprint: (r: SM<any>) => !r.task,
    backlog: (r: SM<any>) => !r.task,
    closed: (r: SM<any>) => !r.task,
    all: (r: SM<any>) => !r.task,
};

export const MAIN_MENU_HIDDEN_FN = (id: string, r: SM<any>) => {
    return mmhf[id] ? mmhf[id](r) : false;
}

export const PREDEFINED_MAIN_MENU_ITEMS: SM<ModelTemplate<MainMenuItem, '_vis'>> = {
    dashboard: {
        id: 'dashboard',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Обзор',
        icon: 'vzi-dashboard',
        route: ['dashboard'],
    },
    mentions: {
        id: 'mentions',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Упоминания',
        icon: 'vzi-email',
        route: ['mentions'],
        counters: ['mentions', 'unread', ''],
    },
    events: {
        id: 'events',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'События',
        icon: 'vzi-calendar1 top-1',
        route: ['events'],
        counters: ['calendar', 'upcoming', 'total'],
    },
    projects: {
        id: 'projects',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Проекты',
        icon: 'vzi-project',
        route: ['settings', 'projects'],
    },
    kanbans: {
        id: 'kanbans',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Канбан доски',
        icon: 'vzi-kanban',
        route: ['settings', 'boards'],
    },
    tasks: {
        id: 'tasks',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Задачи',
        icon: 'vzi-all-tasks',
        route: ['tasks'],
        counters: ['tasks', 'inboxUnread', 'inboxAll']
    },
    newtask: {
        id: 'newtask',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Новая задача',
        icon: 'vzi-plus txt-ok-ll',
        routeFull: [{ outlets: { g: ['newtask'] }}],
        queryParams: { pid: '' },
        queryParamsHandling: 'merge',
    },
    settings: {
        id: 'settings',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Настройки',
        icon: 'vzi-settings',
        route: ['settings'],
        matchRouterExact: [false, true],
    },
    profile: {
        id: 'profile',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Профиль',
        icon: 'vzi-person',
        route: ['settings', 'profile'],
    },
    support: {
        id: 'support',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Тех. поддержка',
        icon: 'vzi-support_agent',
        route: ['tickets'],
        counters: ['tasks', 'supportUnread', 'supportAll'],
    },
    chats: {
        id: 'chats',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Чаты',
        icon: 'vzi-chat',
        route: ['chats'],
        counters: ['chats', '', 'unreadChatsTotal'],
    },
    docs: {
        id: 'docs',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Справка',
        icon: 'vzi-question',
        routeExternal: 'https://wiki.vizorro.ru',
    },
    tariffs: {
        id: 'tariffs',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Тарификация',
        icon: 'fd-n',
        iconText: '₽',
        route: ['billing'],
    },
    uploads: {
        id: 'uploads',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Загрузка файлов',
        icon: 'vzi-attach',
        routeFull: [{ outlets: { g: ['uploads'] }}],
    },
    tgnews: {
        id: 'tgnews',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Новости в телеграм',
        icon: 'vzi-telegram txt-inv',
        routeExternal: 'https://t.me/VIZORRO_news',
    },
    download: {
        id: 'download',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Скачать приложение',
        icon: 'vzi-in fs-xl',
        route: ['downloads'],
    },
    groups: {
        id: 'groups',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Группы',
        icon: 'vzi-team',
        route: ['settings', 'groups'],
    },
    roles: {
        id: 'roles',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Роли',
        icon: 'vzi-local_police',
        route: ['settings', 'roles'],
    },
    employees: {
        id: 'employees',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Сотрудники',
        icon: 'vzi-group',
        route: ['settings', 'employees'],
    },
    tags: {
        id: 'tags',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Теги',
        icon: 'vzi-tags',
        route: ['settings', 'tags'],
    },
    integrations: {
        id: 'integrations',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Интеграции',
        icon: 'vzi-webhooks',
        route: ['settings', 'integrations'],
    },
    notifications: {
        id: 'notifications',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Уведомления',
        icon: 'vzi-bell',
        route: ['settings', 'notifications'],
    },
    reports: {
        id: 'reports',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Отчеты',
        icon: 'vzi-stats-dots',
        route: ['reports'],
    },
    wiki: {
        id: 'wiki',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'База знаний',
        icon: 'vzi-book',
        route: ['wiki'],
    },



    // menu folders
    tasksFolder: {
        id: 'tasksFolder',
        unique: true,
        icon: 'vzi-all-tasks',
        type: MainMenuItemType.Folder,
        title: 'Задачи',
        subtype: MainMenuFolderType.Tasks,
        counters: ['tasks', 'inboxUnread', 'inboxAll']
    },
    kanbansFolder: {
        id: 'kanbansFolder',
        unique: true,
        icon: 'vzi-kanban',
        type: MainMenuItemType.Folder,
        title: 'Канбан доски',
        subtype: MainMenuFolderType.Kanbans,
    },
    groupChatsFolder: {
        id: 'groupChatsFolder',
        unique: true,
        icon: 'vzi-chat',
        type: MainMenuItemType.Folder,
        title: 'Групповые чаты',
        subtype: MainMenuFolderType.GroupChats,
        counters: ['chats', 'unreadGroup', ''],
        maxCount: 10,
        editable: true,
    },
    directChatsFolder: {
        id: 'directChatsFolder',
        unique: true,
        icon: 'vzi-comment-o',
        type: MainMenuItemType.Folder,
        title: 'Персональные чаты',
        subtype: MainMenuFolderType.DirectChats,
        counters: ['chats', 'unreadDirect', ''],
        maxCount: 10,
        editable: true,
    },
    customFolder: {
        type: MainMenuItemType.Folder,
        icon: 'vzi-folder-o',
        title: 'Пользовательская группа',
        subtype: MainMenuFolderType.Custom,
        editable: true,
    },

    // task filters AKA папки
    favorites: {
        id: 'favorites',
        unique: true,
        type: MainMenuItemType.TaskFilter,
        title: 'Избранные',
        icon: 'vzi-star',
        filterId: 'favorites',
        counters: ['tasks', 'favoriteUnread', 'favoriteAll'],
    },
    inbox: {
        id: 'inbox',
        unique: true,
        type: MainMenuItemType.TaskFilter,
        title: 'Входящие',
        icon: 'vzi-inbox',
        filterId: 'inbox',
        counters: ['tasks', 'inboxUnread', 'inboxAll'],
    },
    outgoing: {
        id: 'outgoing',
        unique: true,
        type: MainMenuItemType.TaskFilter,
        title: 'Исходящие',
        icon: 'vzi-send',
        filterId: 'outgoing',
        counters: ['tasks', '', 'outbox'],
    },
    inprogress: {
        id: 'inprogress',
        unique: true,
        type: MainMenuItemType.TaskFilter,
        title: 'В работе',
        icon: 'vzi-construction',
        filterId: 'inprogress',
        counters: ['tasks', 'inprogressUnread', 'inprogressAll'],
    },
    sprint: {
        id: 'sprint',
        unique: true,
        type: MainMenuItemType.TaskFilter,
        title: 'Активные',
        icon: 'vzi-fire',
        filterId: 'sprint',
        counters: ['tasks', '', 'sprint'],
    },
    backlog: {
        id: 'backlog',
        unique: true,
        type: MainMenuItemType.TaskFilter,
        title: 'Отложенные',
        icon: 'vzi-stack',
        filterId: 'backlog',
        counters: ['tasks', '', 'backlog'],
    },
    closed: {
        id: 'closed',
        unique: true,
        type: MainMenuItemType.TaskFilter,
        title: 'В архиве',
        icon: 'vzi-done',
        filterId: 'closed',
        counters: ['tasks', '', 'closed'],
    },
    all: {
        id: 'all',
        unique: true,
        type: MainMenuItemType.TaskFilter,
        title: 'Все задачи',
        icon: 'vzi-all-tasks',
        filterId: 'all',
        counters: ['tasks', '', '_total'],
    },

    // helper elements
    separator: {
        type: MainMenuItemType.Separator
    },
    spacer: {
        id: 'spacer',
        unique: true,
        type: MainMenuItemType.FlexSpace
    },

};
// Object.keys(PREDEFINED_MAIN_MENU_ITEMS).forEach(id => PREDEFINED_MAIN_MENU_ITEMS[id].id = id);

export const PREDEFINED_MAIN_MENU_CATEGORIES: NM<ModelTemplate<MainMenuItem, '_vis'>[]> = {
    [MainMenuItemType.Link]: Object.values(PREDEFINED_MAIN_MENU_ITEMS).filter(x => x.type == MainMenuItemType.Link).sort((a, b) => a.title!.localeCompare(b.title!)),
    [MainMenuItemType.Folder]: Object.values(PREDEFINED_MAIN_MENU_ITEMS).filter(x => x.type == MainMenuItemType.Folder).sort((a, b) => a.title!.localeCompare(b.title!)),
    [MainMenuItemType.TaskFilter]: Object.values(PREDEFINED_MAIN_MENU_ITEMS).filter(x => x.type == MainMenuItemType.TaskFilter).sort((a, b) => a.title!.localeCompare(b.title!)),
    [MainMenuItemType.Unknown]: [PREDEFINED_MAIN_MENU_ITEMS.separator, PREDEFINED_MAIN_MENU_ITEMS.spacer]
};
